import { ref } from "vue";
import { DraggerType } from "@/drawing/draggers/types";

/**
 * Édition du plan verrouillée — pendant une fusion de versions (analyse,
 * résolution des conflits, application) : une modification faite à ce moment-là
 * serait écrasée par le résultat, ou ferait échouer la fusion.
 *
 * Bloqués : le choix d'un outil d'édition (DraggerMenuState), les barres
 * d'outils (CanvasLayout), les raccourcis d'édition (KeyHandler), l'autosave
 * (SaveDrawingState) et, en filet de sécurité, toute commande (CommandHistory).
 * Libres : la navigation (déplacement, zoom), pour aller voir les modifications.
 *
 * Module feuille : posé par BranchMergeState, lu partout ailleurs.
 */
export const editingLocked = ref(false);

/**
 * Outils permis pendant le verrouillage : ils ne modifient pas le plan.
 * `None` = aucun outil : déplacement et zoom au doigt, à la souris ou à la
 * molette (pas d'outil « pan » enregistré dans le moteur).
 */
export const NAVIGATION_DRAGGERS: readonly DraggerType[] = [
  DraggerType.None,
  DraggerType.ZoomWindow,
];
